import axios from "axios";
import { Category } from "../models/category.model";
import { Option } from "../models/components.model";
import { getMockCompanyOptions } from "./mocks/mock-data.service";
import appConfig from "../appConfig";


export class CategoryService {
  static async fetchCategories(): Promise<Category[]> {
    try {
      const response = await axios.get(`${appConfig.BASE_URL}/config/vertical`);
      return response?.data?.data;
    } catch (error) {
      // Handle the error, e.g., logging it or returning an empty array
      console.error('Error fetching categories:', error);
      return [];
    }
  }
  
  static async fetchCategoryOptions(): Promise<Option[]> {
    try {
      const options = await getMockCompanyOptions();
      return options;
    } catch (error) {
      // Handle the error, e.g., logging it or returning an empty array
      console.error('Error fetching company options:', error);
      return [];
    }
  }

  static findCategoryInOptions = (options: Option[], category: Category | undefined) => {
    return options?.some(opt => opt.label === category?.name);
  }
}